import axios from "axios";
const actions = {
    addItemToMhdInventory({commit, getters}, data) {
        let mhdItems = getters.getMHDInventoryItems
        mhdItems.push(data)
        let params = {
            control_list: mhdItems
        }
        axios.post('api/mhd-control/update-control-list', params).then(r => {
            if(r.data.status === 0) {
                commit('setMHDItems', r.data.mhd_list)
            }
        })
    },
    removeItemFromMhdInventory({commit, getters}, data) {
        let mhdItems = getters.getMHDInventoryItems
        mhdItems.splice(data, 1)
        let params = {
            control_list: mhdItems
        }
        axios.post('api/mhd-control/update-control-list', params).then(r => {
            if(r.data.status === 0) {
                commit('setMHDItems', r.data.mhd_list)
            }
        })
    },
    fetchPersonalMHDControlList({commit}) {
        axios.get('api/mhd-control/get-control-list').then(r => {
            if(r.data.status === 0) {
                commit('setMHDItems', r.data.mhd_list ? r.data.mhd_list : [])
            }
        })
    },
    fetchAllOpenControlLists() {
        return new Promise(resolve => {
            axios.get('api/mhd-control/get-cumulated-control-lists').then(r => {
                if(r.data.status === 0) {
                    resolve(r.data.control_lists)
                }
            })
        })
    },
    removeItemFromOpenControlList({getters}, data) {
        let mhdItems = getters.getMHDInventoryItems
        console.log(mhdItems.length)
        return new Promise(resolve => {
            axios.get('api/mhd-control/remove-from-cumulated-list/'+data.parentId+'/'+data.internalId).then(r => {
                if(r.data.status === 0) {
                    resolve(r.data.control_lists)
                }
            })
        })
    },
    createFinalControlList({commit}) {
        return new Promise(resolve => {
            axios.get('api/mhd-control/create-final-control-list').then(r => {
                if(r.data.status === 0) {
                    commit('setMHDItems', [])
                    resolve(true)
                } else {
                    resolve(false)
                }
            })
        })
    }
}

export default actions
